import { VirtualExperience } from './virtual-experience';
import { VirtualExperienceProps } from './virtual-experience-core';
import styled from '@emotion/styled';
// import { useUser } from '@project/hooks/use-user';
import { useFlag } from '@project/providers/flags-provider';
import { AdhocTalkRequest } from '@project/site/modules/adhoc-request';
import { useAdhocSettings } from '@project/site/modules/adhoc-request/use-adhoc-settings';

type SidebarOptions = {
  adhoc_appointment?: boolean;
};

export const VirtualExperienceWithSidebar: React.FC<VirtualExperienceProps & SidebarOptions> = (
  props,
) => {
  const { adhoc_appointment, ...videoExperienceProps } = props;
  const adhocSettings = useAdhocSettings();
  const adHocTimes = useFlag(adhocSettings.adhocTimesFlag);
  // const { isAuthenticated } = useUser();

  if (!adHocTimes) {
    return <VirtualExperience {...videoExperienceProps} />;
  }

  if (!adhoc_appointment) {
    return <VirtualExperience {...videoExperienceProps} />;
  }

  return (
    <VeWithSidebarWrapper>
      <div className="ve-wrapper">
        <VirtualExperience {...videoExperienceProps} />
      </div>
      <div className="sidebar">{adhoc_appointment ? <AdhocTalkRequest /> : null}</div>
    </VeWithSidebarWrapper>
  );
};

const VeWithSidebarWrapper = styled.div`
  .cue-virtual-experience-wrapper {
    margin-bottom: 0;
  }

  display: grid;
  grid-template-columns: 2fr 350px; /* 2 parts for the content area and 1 part for the sidebar */
  grid-gap: 1rem; /* gap between the content area and sidebar */

  .ve-wrapper {
    grid-column: 1 / 3; /* occupy the first column */

    @media only screen and (min-width: 1200px) {
      grid-column: 1 / 2; /* occupy the first column */
      grid-row: 1 / 2; /* occupy the first row */
    }
  }

  .sidebar {
    grid-column: 1 / 3; /* occupy the second column */

    @media only screen and (min-width: 1200px) {
      grid-column: 2 / 3; /* occupy the second column */
    }
  }
`;
